import shell from "shelljs";

shell.exec("./pre-push.sh");
